import MultiLanguageDesignationModel from './MultiLanguageDesignationModel';
import * as AT from '../../components/container/attributes';
import yaml from '@hit/components/src/utils/yaml/yaml';
import {isValidFormDefYaml} from 'hit-online-web-ui/src/views/form/FormUtils';

export default class FormDefinitionNew extends MultiLanguageDesignationModel {
  constructor({
    id,
    number = '',
    designationFrBe = undefined,
    designationDeBe = undefined,
    designationNlBe = undefined,
    designationFrLu = undefined,
    designationDeLu = undefined,
    designationFrFr = undefined,
    designationDeDe = undefined,
    designationNlNl = undefined,
    designationEnGb = undefined,
    designationEnIn = undefined,
    designationMrIn = undefined,
    designationHiIn = undefined,
    active = true,
    definition = undefined,
    creationRoles = undefined,
    supervisorGroupRoles = undefined,
    supervisorLinkedRoles = undefined,
  }) {
    super({
      id,
      number,
      designationFrBe,
      designationDeBe,
      designationNlBe,
      designationFrLu,
      designationDeLu,
      designationFrFr,
      designationDeDe,
      designationNlNl,
      designationEnGb,
      designationEnIn,
      designationMrIn,
      designationHiIn,
    });
    this.active = active;
    this.definition = definition ? yaml.toJson(definition) : undefined;
    this.validSyntax = definition ? isValidFormDefYaml(definition) : undefined;
    this.creationRoles = creationRoles;
    this.supervisorGroupRoles = supervisorGroupRoles;
    this.supervisorLinkedRoles = supervisorLinkedRoles;
  }

  static get fkName() {
    return 'form_definition_id';
  }
  static get apiRoute() {
    return 'form_definition';
  }
  static get listPageRoute() {
    return 'formDefinitionList';
  }
  static get detailPageRoute() {
    return 'standardFormDefinitionItem';
  }
  static get createInitColumns() {
    return {};
  }
  get fkName() {
    return FormDefinitionNew.fkName;
  }
  get apiRoute() {
    return FormDefinitionNew.apiRoute;
  }
  get detailPageRoute() {
    return FormDefinitionNew.detailPageRoute;
  }
  get listPageRoute() {
    return FormDefinitionNew.listPageRoute;
  }
  static get orderKey() {
    return this.attributeUserLocale('designation', true);
  }

  static get defaultSort() {
    return {
      property: this.attributeUserLocale('designation'),
      order: 'asc',
    };
  }

  getDefaultSort() {
    return FormDefinitionNew.defaultSort;
  }

  static get orderKeyEmbedded() {
    return this.attributeUserLocale('designation', false);
  }

  static get config() {
    return {
      addable: false,
      duplicatable: false,
      importable: false,
      browsable: false,
      deletable: true,
    };
  }

  get config() {
    return FormDefinitionNew.config;
  }

  static get dataListConfig() {
    return {
      zone1CustomFunction: (data) =>
        data[this.attributeCompanyLocale('designation')] || '',
      zone2CustomFunction: (data) =>
        data[this.attributeUserLocale('designation')] || '',
    };
  }
  get dataListConfig() {
    return FormDefinitionNew.dataListConfig;
  }

  static get listDisplayAttrs() {
    return this.getAttributes(
      [
        this.attributeUserLocale('designation'),
        this.attributeCompanyLocale('designation'),
        'validSyntax',
        'active',
      ],
      ['definition'],
    );
  }

  static get browserDisplayAttrs() {
    return this.getAttributes(
      [
        this.attributeUserLocale('designation'),
        this.attributeCompanyLocale('designation'),
      ],
      ['definition', 'active'],
    );
  }

  static get joinAttrsKey() {
    return [
      this.attributeUserLocale('designation'),
      this.attributeCompanyLocale('designation'),
    ];
  }

  static get joinFilterColumns() {
    return [
      this.attributeUserLocale('designation', true),
      this.attributeCompanyLocale('designation', true),
    ];
  }

  static get allAttributes() {
    return [
      this.ACTIVE_ATTRIBUTE(),
      new AT.ArrayAttribute({
        name: 'creationRoles',
        column: 'creation_roles',
        tableProperties: {
          header: 'hit-app.form.creation-roles',
        },
      }),
      new AT.ArrayAttribute({
        name: 'supervisorGroupRoles',
        column: 'supervisor_group_roles',
        tableProperties: {
          header: 'hit-app.form.supervisor-group-roles',
        },
      }),
      new AT.ArrayAttribute({
        name: 'supervisorLinkedRoles',
        column: 'supervisor_linked_roles',
        tableProperties: {
          header: 'hit-app.form.supervisor-linked-roles',
        },
      }),
      new AT.StringAttribute({
        name: 'mail',
        column: 'mail_recipients',
        tableProperties: {
          header: 'hit-base.common.mail',
        },
      }),
      new AT.StringAttribute({
        name: 'definition',
        tableProperties: {
          header: 'hit-base.common.data',
        },
      }),
      new AT.NotFetchedAttribute({
        name: 'validSyntax',
        tableProperties: {
          header: 'hit-app.form.syntax',
        },
      }),
    ].concat(
      this.generateMultiLanguageField({
        key: 'designation',
        attributeClass: AT.StringAttribute,
        header: 'hit-base.common.designation',
      }),
    );
  }
}
